import { MediaElement } from 'editor/src/store/design/types';
import { RootState } from 'editor/src/store/index';

const isMediaElementSizeRatioUnlocked = (state: RootState, element: MediaElement) =>
  element.type === 'text' || state.editor.unlockSizeRatioElementUuids.indexOf(element.uuid) !== -1;

export default isMediaElementSizeRatioUnlocked;
